// src/untils/versionCheck.js
import { MessageBox } from 'element-ui'

const STORAGE_KEY = 'app_version'
const IGNORE_KEY = 'ignored_version'
let isRefreshing = false
let timer = null

// 从 HTML 中提取版本号
async function fetchVersionFromHtml() {
    const url = `/index.html?t=${Date.now()}`
    const response = await fetch(url, { cache: 'no-cache' })
    const html = await response.text()
    const match = html.match(/<meta name="version" content="([^"]+)"/)
    if (match) return match[1]
    throw new Error('未找到版本号 meta 标签')
}

// 同步本地版本号与当前页面实际版本（解决刷新后重复提示）
export async function syncVersionFromHtml() {
    try {
        const newVersion = await fetchVersionFromHtml()
        const oldVersion = localStorage.getItem(STORAGE_KEY)
        if (!oldVersion || oldVersion !== newVersion) {
            localStorage.setItem(STORAGE_KEY, newVersion)
        }
    } catch (err) {
        console.error('[版本同步失败]', err)
    }
}

export async function checkVersion(showTip = true) {
    // 如果是本地开发（localhost 或 127.0.0.1），跳过检测
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return
    }

    if (isRefreshing) return

    try {
        const newVersion = await fetchVersionFromHtml()
        const oldVersion = localStorage.getItem(STORAGE_KEY)

        // 首次访问，保存版本号
        if (!oldVersion) {
            localStorage.setItem(STORAGE_KEY, newVersion)
            return
        }

        // 版本不一致
        if (oldVersion !== newVersion && !isRefreshing) {
            isRefreshing = true

            // 检查用户是否已经忽略了这个版本
            const ignoredVersion = localStorage.getItem(IGNORE_KEY)
            if (ignoredVersion === newVersion) {
                isRefreshing = false
                return
            }

            if (showTip) {
                MessageBox.confirm('检测到新版本，是否立即刷新页面？', '版本更新', {
                    confirmButtonText: '立即刷新',
                    cancelButtonText: '稍后手动刷新',
                    type: 'info',
                    distinguishCancelAndClose: true
                }).then(() => {
                    // 用户点击立即刷新，保存新版本并清除忽略标记
                    localStorage.setItem(STORAGE_KEY, newVersion)
                    localStorage.removeItem(IGNORE_KEY)
                    window.location.reload(true)
                }).catch((action) => {
                    if (action === 'cancel') {
                        // 用户点击稍后手动刷新，记录忽略的版本，不再重复弹窗
                        localStorage.setItem(IGNORE_KEY, newVersion)
                        MessageBox.alert('已记录，请稍后手动刷新页面来获取新版本。', '提示', { type: 'info' })
                        isRefreshing = false
                    } else {
                        // 点击右上角关闭，不做处理
                        isRefreshing = false
                    }
                })
            } else {
                // 静默模式（通常不用）
                localStorage.setItem(STORAGE_KEY, newVersion)
                window.location.reload(true)
            }
        }
    } catch (err) {
        console.error('[版本检测失败]', err)
    }
}

export function startVersionPolling(interval = 10 * 60 * 1000, showTip = true) {
    if (timer) clearInterval(timer)
    // 启动时先同步一次版本号，确保本地存储与当前页面版本一致
    syncVersionFromHtml().then(() => {
        setTimeout(() => checkVersion(showTip), 5000)
    })
    timer = setInterval(() => checkVersion(showTip), interval)
}

export function stopVersionPolling() {
    if (timer) {
        clearInterval(timer)
        timer = null
    }
}